import { render } from "./admin-dashboard.vue?vue&type=template&id=75f94084"
import script from "./admin-dashboard.vue?vue&type=script&lang=js"
export * from "./admin-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__